export default __webpack_public_path__ + "static/media/Dune-hd-3.ac236524.jpg";